import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import { ThemeProvider } from './components/theme-provider.tsx'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/query-client'

// Define widget namespace for message handling
declare global {
  interface Window {
    DzinlyWidget: {
      onMessage: (handler: (message: any) => void) => void;
      sendMessage: (message: any) => void;
    };
  }
}

// Setup widget API for communication with parent window
window.DzinlyWidget = {
  onMessage: (handler) => {
    window.addEventListener('message', (event) => {
      // Validate origin for security
      // This should be updated to match Dzinly's domain in production
      const allowedOrigins = ['http://localhost:3000', 'https://dzinly.com', 'https://dzinly.in/'];
      if (allowedOrigins.includes(event.origin)) {
        handler(event.data);
      }
    });
  },
  sendMessage: (message) => {
    // Send message to parent window
    if (window.parent !== window) {
      window.parent.postMessage(message, '*');
    }
  }
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="dzinly-ui-theme">
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)